import { render, staticRenderFns } from "./DocketNumber.vue?vue&type=template&id=1825a924&"
import script from "./DocketNumber.vue?vue&type=script&lang=js&"
export * from "./DocketNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports